(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sip-about-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sip-about-story')) {
    class SipAboutStory extends HTMLElement {
      connectedCallback() {
        this.clip = this.querySelector('.sip-about-story__clip');
        if (!this.clip) return;
        this.tile = this.clip.closest('.sip-about-story__media');
        this.inView = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.ac = new AbortController();
        const { signal } = this.ac;
        const v = this.clip;

        v.muted = true;
        v.loop = true;
        // The still lifts once frames are actually moving and settles back on
        // pause, so there is never a black frame between the two.
        v.addEventListener('playing', () => this.classList.add('sip-about-story--playing'), { signal });
        v.addEventListener('pause', () => this.classList.remove('sip-about-story--playing'), { signal });
        v.addEventListener('error', () => this.stop(), { signal });
        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) this.stop();
            else if (this.inView) this.start();
          },
          { signal }
        );

        // Reduce motion: nothing moves on its own. The still stays and a tap
        // plays and pauses the clip.
        if (this.reduced.matches) {
          this.classList.add('sip-about-story--tap');
          this.tile.addEventListener('click', () => this.tap(), { signal });
          return;
        }

        // Two watchers on the clip box, rooted in the nearest scroll container
        // (the page wrapper on desktop; the window otherwise). A window-rooted
        // margin would be clipped at the wrapper's edge and never fire early.
        // The first fires half a screen early and only fetches the file, which
        // preload="none" has held back until now. The second plays once a
        // quarter of the box is in view and pauses when it scrolls out. On a
        // phone the box is display:none, so neither fires and nothing downloads.
        const root = this.scroller();
        this.near = new IntersectionObserver(
          (entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            this.near.disconnect();
            v.preload = 'auto';
            // Both watchers can fire in the same frame in either order. If play
            // was already asked for it is fetching, and load() would reset it.
            if (v.paused) v.load();
          },
          { root, rootMargin: '50% 0px' }
        );
        this.view = new IntersectionObserver(
          (entries) => {
            this.inView = entries[entries.length - 1].isIntersecting;
            if (this.inView) this.start();
            else this.stop();
          },
          { root, threshold: 0.25 }
        );
        this.near.observe(this.tile);
        this.view.observe(this.tile);
      }

      disconnectedCallback() {
        this.ac?.abort();
        this.near?.disconnect();
        this.view?.disconnect();
        this.stop();
      }

      scroller() {
        for (let n = this.parentElement; n && n !== document.body; n = n.parentElement) {
          const o = getComputedStyle(n).overflowY;
          if (o === 'auto' || o === 'scroll') return n;
        }
        return null;
      }

      start() {
        this.clip.play().catch(() => {});
      }

      stop() {
        if (!this.clip.paused) this.clip.pause();
      }

      tap() {
        if (this.clip.paused) this.start();
        else this.stop();
      }
    }
    customElements.define('sip-about-story', SipAboutStory);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sip-hero-wordmark"] && !Shopify.designMode) return;
  try {
    /**
   * Places the wordmark artwork. The SVG has a tight viewBox, so width alone
   * places it exactly; there is nothing to measure and no webfont to wait for.
   */
  class SipHeroWordmark extends HTMLElement {
    connectedCallback() {
      this.markEl = this.querySelector('[data-sip-hw-mark]');
      if (!this.markEl) return;

      this.fit = this.fit.bind(this);
      this.fit();

      this.observer = new ResizeObserver(this.fit);
      this.observer.observe(this);

      this.setupLogoReveal();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onScroll && this.scrollers) {
        this.scrollers.forEach((el) => el.removeEventListener('scroll', this.onScroll));
      }
      if (this.logoEl) this.logoEl.removeAttribute('data-wordmark-passed');
    }

    /**
     * The header script logo stays hidden while the page is parked at the top
     * with the wordmark in full view, and fades in the moment the visitor starts
     * scrolling. Mike's review note (Sep 2026): the logo should pop up as soon as
     * scrolling starts, not wait for the whole wordmark to pass under the header.
     *
     * Only engages when "Hide logo on home page" is ticked on the header logo
     * block, which is what renders data-hidden-on-home-page; untick it and the
     * header logo behaves like stock Horizon again. The attribute keeps its
     * original name so the CSS in blocks/_header-logo.liquid is unchanged:
     * "false" at the top of the page, "true" once scrolled.
     */
    setupLogoReveal() {
      const logo = document.querySelector('.header-logo[data-hidden-on-home-page]');
      if (!logo) return;

      /* A few pixels of slack so trackpad jitter at the very top of the page
         does not flicker the logo on and off. */
      const THRESHOLD = 4;

      this.logoEl = logo;

      /* On desktop this theme scrolls inside .page-wrapper (html and body are
         overflow: hidden there), not the window; on phones the window scrolls.
         Listen to both and take whichever has moved. */
      this.scrollers = [window];
      const wrapper = document.querySelector('.page-wrapper');
      if (wrapper) this.scrollers.push(wrapper);

      let frame = 0;
      const update = () => {
        frame = 0;
        const y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
        logo.setAttribute('data-wordmark-passed', y > THRESHOLD ? 'true' : 'false');
      };
      this.onScroll = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };

      update();
      this.scrollers.forEach((el) => el.addEventListener('scroll', this.onScroll, { passive: true }));
    }

    fit() {
      const style = getComputedStyle(this);

      /* 55.5% of a 1440 screen is a statement; 55.5% of a 390 screen is timid, and
         the wordmark carrying the hero is the whole point of the composition. So the
         share of the screen it takes is a separate number on phones. 750px is
         Horizon's own breakpoint (base.css). */
      const MOBILE_BREAKPOINT = 750;
      const isMobile = document.documentElement.clientWidth < MOBILE_BREAKPOINT;
      const targetPct = parseFloat(
        style.getPropertyValue(isMobile ? '--sip-hw-target-mobile' : '--sip-hw-target')
      ) || (isMobile ? 85 : 55.5);

      /* Against the viewport, not this element: the mock's 55.5% was measured off
         the 1440 frame, and the hero sits inside a page-width column that is
         narrower than the frame. Capped to the element so it can never spill out
         of its own column on an unusually wide window. */
      const viewport = document.documentElement.clientWidth;
      const markTarget = Math.min((targetPct / 100) * viewport, this.clientWidth);
      this.markEl.style.width = `${markTarget}px`;

      /* Where the S starts, measured in from the hero's content edge. The
         artwork is centred in this block and its viewBox is cut to the ink, so
         the left of the S is exactly half the leftover width. Published on the
         section so the tagline block below can start its line on the same
         edge. The CSS in this file sets the same number pre-fit; this is the
         exact px version, off the same clientWidth as the width above. */
      const section = this.closest('.shopify-section') || this.parentElement;
      if (section) {
        section.style.setProperty('--sip-hw-mark-offset', `${Math.max(0, (this.clientWidth - markTarget) / 2)}px`);
      }
    }
  }

  if (!customElements.get('sip-hero-wordmark')) {
    customElements.define('sip-hero-wordmark', SipHeroWordmark);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sip-model-sheet"] && !Shopify.designMode) return;
  try {
    /**
   * Variant viewer on the model pages. Clicking or tapping a variant name (or
   * Enter/Space on it) brings that drawing up and writes its name into the
   * heading. Hover and focus alone no longer select (Mike, Sep 2026).
   */
  class SipVariantViewer extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-vv-key]'));
      this.slides = Array.from(this.querySelectorAll('.sip-vv__slide'));
      this.nameEl = this.querySelector('[data-vv-name]');
      this.sidingNameEl = this.querySelector('[data-vv-siding-name]');
      this.priceEls = Array.from(this.querySelectorAll('[data-vv-price]'));
      this.sidings = Array.from(this.querySelectorAll('[data-vv-siding]'));
      this.sidingPhotos = Array.from(this.querySelectorAll('[data-vv-siding-photo]'));
      this.sidingNotes = Array.from(this.querySelectorAll('[data-vv-siding-note]'));
      this.siding = 0;
      this.current = this.options[0];
      try {
        this.prices = JSON.parse(this.dataset.prices || '[]');
      } catch (e) {
        this.prices = [];
      }
      this.showCycle();

      this.options.forEach((button) => {
        button.addEventListener('click', () => this.show(button));
      });
      this.sidings.forEach((button) => {
        button.addEventListener('click', () => this.pickSiding(button));
      });
    }

    pickSiding(button) {
      this.siding = Number(button.dataset.vvSiding) || 0;
      this.sidings.forEach((b) => b.setAttribute('aria-pressed', b === button ? 'true' : 'false'));
      this.sidingPhotos.forEach((img) => img.toggleAttribute('data-active', Number(img.dataset.vvSidingPhoto) === this.siding));
      const hasPhoto = this.sidingPhotos.some((img) => Number(img.dataset.vvSidingPhoto) === this.siding);
      this.sidingNotes.forEach((note) => note.toggleAttribute('data-active', !hasPhoto));
      if (this.sidingNameEl) this.sidingNameEl.textContent = button.textContent.trim();
      this.update();
    }

    /* The build cycle quarter, worked out from today's date (see the Liquid above). */
    showCycle() {
      const el = this.querySelector('[data-vv-cycle]');
      if (!el) return;
      try {
        const c = JSON.parse(this.dataset.cycle || '{}');
        const now = new Date();
        const ym = now.getFullYear() * 12 + now.getMonth() + 1;
        const steps = ym >= c.shift ? Math.floor((ym - c.shift) / c.step) + 1 : 0;
        const i = c.q - 1 + steps;
        el.textContent = 'Q' + ((i % 4) + 1) + ' ' + (c.y + Math.floor(i / 4));
      } catch (e) {
        /* keep the quarter the page was built with */
      }
    }

    /* The variant, full price and door note for the option and siding showing. */
    update() {
      const button = this.current;
      if (!button) return;
      const key = button.dataset.vvKey;
      const vest = key.endsWith('-v') ? 1 : 0;
      const row = this.prices[this.siding];
      if (row && row[vest]) {
        const price = '$' + Number(row[vest]).toLocaleString('en-CA');
        this.priceEls.forEach((el) => { el.textContent = price; });
      }
      const idInput = this.querySelector('[data-vv-variant]');
      let ids = [];
      try {
        ids = JSON.parse(button.dataset.variants || '[]');
      } catch (e) {
        ids = [];
      }
      const vid = ids[this.siding];
      if (idInput && vid) idInput.value = vid;
      const door = this.querySelector('[data-vv-door]');
      if (door) door.value = key.startsWith('lh') ? 'Right hand door' : 'Left hand door';
    }

    show(button) {
      this.current = button;
      const key = button.dataset.vvKey;
      this.slides.forEach((slide) => {
        const on = slide.dataset.key === key;
        slide.toggleAttribute('data-active', on);
        if (on) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.options.forEach((option) => {
        option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
      });
      if (this.nameEl) this.nameEl.textContent = button.dataset.vvName;
      this.update();
    }
  }

  if (!customElements.get('sip-variant-viewer')) {
    customElements.define('sip-variant-viewer', SipVariantViewer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sip-people"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sip-people')) {
    class SipPeople extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('.sip-people__row');
        this.tiles = [...this.querySelectorAll('.sip-people__tile')];
        this.allClips = [...this.querySelectorAll('.sip-people__clip')];
        if (!this.allClips.length) return;

        this.turn = 0;
        this.hovered = null;
        this.inView = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.phone = matchMedia('(max-width: 749px)');
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.ac = new AbortController();
        const { signal } = this.ac;
        this.pickClips();

        this.allClips.forEach((v) => {
          v.muted = true;
          v.addEventListener('ended', () => this.onEnded(v), { signal });
          v.addEventListener('error', () => this.onEnded(v), { signal });
          // The resting still lifts only once the clip is genuinely running,
          // and drops back the moment it stops. Keyed off the media events
          // rather than off play(), so a play() that is refused or interrupted
          // cannot leave the tile showing a bare video frame.
          const tile = v.closest('.sip-people__tile');
          v.addEventListener('playing', () => tile.setAttribute('data-playing', ''), { signal });
          ['pause', 'ended', 'error', 'emptied', 'stalled'].forEach((e) => {
            v.addEventListener(e, () => tile.removeAttribute('data-playing'), { signal });
          });
        });

        // Reduce motion: posters stand, a tap plays the tile you touched.
        if (this.reduced.matches) {
          this.classList.add('sip-people--tap');
          this.allClips.forEach((v) => {
            v.closest('.sip-people__tile').addEventListener('click', () => this.tap(v), { signal });
          });
          return;
        }

        this.io = new IntersectionObserver(
          ([entry]) => {
            this.inView = entry.isIntersecting;
            if (this.inView) this.resume();
            else this.pauseAll();
          },
          { threshold: 0.2 }
        );
        this.io.observe(this);

        this.allClips.forEach((v) => {
          const tile = v.closest('.sip-people__tile');
          tile.addEventListener('pointerenter', () => this.enter(v), { signal });
          tile.addEventListener('pointerleave', () => this.leave(v), { signal });
        });
        this.row.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
        this.phone.addEventListener(
          'change',
          () => {
            this.hovered = null;
            this.pauseAll();
            this.pickClips();
            this.resume();
          },
          { signal }
        );
        document.addEventListener(
          'visibilitychange',
          () => (document.hidden ? this.pauseAll() : this.resume()),
          { signal }
        );
      }

      disconnectedCallback() {
        this.ac?.abort();
        this.io?.disconnect();
        cancelAnimationFrame(this.raf);
        this.pauseAll();
      }

      get phoneMode() {
        return this.phone.matches;
      }

      // The clips in play at this width. A "Hide on desktop" place is out of the
      // desktop turn, so nothing hidden plays or prefetches, and its poster is
      // only attached on a phone, so the hidden tile downloads nothing.
      pickClips() {
        const phone = this.phoneMode;
        this.clips = this.allClips.filter((v) => phone || !v.closest('.sip-people__tile--phone-only'));
        if (phone) {
          this.allClips.forEach((v) => {
            if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
          });
        }
        this.turn = 0;
      }

      // A stopped clip rests on its first frame, never on its last. The last
      // frame of a short clip is whatever the person happened to be doing when
      // the camera stopped, which is rarely the frame worth looking at.
      rest(v) {
        if (!v) return;
        if (!v.paused) v.pause();
        if (v.readyState > 0 && v.currentTime !== 0) v.currentTime = 0;
      }

      // One clip at a time: whatever else is moving stops before this one starts.
      play(v, loop) {
        if (!v) return;
        v.loop = loop;
        this.allClips.forEach((o) => {
          if (o !== v) this.rest(o);
        });
        if (v.paused) v.play().catch(() => {});
      }

      pauseAll() {
        this.allClips.forEach((v) => {
          this.rest(v);
        });
      }

      resume() {
        if (!this.inView || document.hidden) return;
        if (this.phoneMode) {
          this.onScroll();
          return;
        }
        if (this.hovered) {
          this.play(this.hovered, true);
          return;
        }
        this.playTurn(this.turn, false);
      }

      // Desktop, nothing hovered: left to right, each clip once, then the next.
      playTurn(i, restart) {
        const v = this.clips[i];
        if (!v) return;
        this.turn = i;
        if (restart) v.currentTime = 0;
        this.play(v, false);
        const next = this.clips[(i + 1) % this.clips.length];
        if (next !== v && next.preload === 'none') next.preload = 'auto';
      }

      onEnded(v) {
        // Back to the first frame before anything else, so the tile never sits
        // on the end of the clip while the next one takes its turn.
        this.rest(v);
        if (this.phoneMode || this.hovered || !this.inView) return;
        const i = this.clips.indexOf(v);
        if (i === this.turn) this.playTurn((i + 1) % this.clips.length, true);
      }

      enter(v) {
        if (!this.hover.matches || this.phoneMode) return;
        this.hovered = v;
        // A hover always starts the clip from its first frame. Before metadata
        // arrives the seek is only a request, so it is repeated once it lands.
        v.currentTime = 0;
        if (v.readyState === 0) {
          v.addEventListener(
            'loadedmetadata',
            () => {
              if (this.hovered === v) v.currentTime = 0;
            },
            { once: true }
          );
        }
        if (this.inView) this.play(v, true);
      }

      leave(v) {
        if (this.hovered !== v) return;
        this.hovered = null;
        this.rest(v);
        if (this.inView && !this.phoneMode) this.playTurn(this.turn, false);
      }

      // Phone: the tile nearest the middle of the strip plays. If that tile is a
      // held place with no clip, nothing plays.
      onScroll() {
        if (!this.phoneMode || !this.inView) return;
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => {
          const r = this.row.getBoundingClientRect();
          const mid = r.left + r.width / 2;
          let best = null;
          let dist = Infinity;
          for (const tile of this.tiles) {
            const b = tile.getBoundingClientRect();
            const d = Math.abs(b.left + b.width / 2 - mid);
            if (d < dist) {
              dist = d;
              best = tile;
            }
          }
          const clip = best?.querySelector('.sip-people__clip');
          if (clip) this.play(clip, true);
          else this.pauseAll();
        });
      }

      tap(v) {
        if (v.paused) this.play(v, true);
        else v.pause();
      }
    }
    customElements.define('sip-people', SipPeople);
  }
  } catch(e) { console.error(e); }
})();

})();
